import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider, getToken } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: 'AIzaSyAp-tcw8yobBvx8YMpnqzWmW0g7VKFVCNQ',
  authDomain: 'dana-assist.firebaseapp.com',
  projectId: 'dana-assist',
  storageBucket: 'dana-assist.firebasestorage.app',
  messagingSenderId: '733336679462',
  appId: '1:733336679462:web:0e41fc1e65b695462a22e7',
  measurementId: 'G-1QH64PC9YL',
};

if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_FIREBASE_DEBUG_TOKEN) {
  (window as any).FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.REACT_APP_FIREBASE_DEBUG_TOKEN;
}

const app = initializeApp(firebaseConfig);

const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6Lch2BEtAAAAAM4ZrO8oZse2Zb-EOnGsc16C0ZRp'),
  isTokenAutoRefreshEnabled: true,
});

export async function getAppCheckToken(): Promise<string | null> {
  try {
    const result = await getToken(appCheck, false);
    return result.token;
  } catch (e) {
    console.error('Failed to get App Check token:', e);
    return null;
  }
}
